export default __webpack_public_path__ + "9afa0de338a61dd162635f410694c232.svg";